import { useCallback, useState } from 'react';

import { AutoSelectClosestStorePromptWrapper } from 'features/store/components/auto-select-closest-store-prompt';
import { StoreTimer } from 'features/store/components/store-timer';
import { View } from 'react-native';

import ErrorNetwork from 'components/error-network';
import LanguageSelectorModal from 'components/language-selector-modal';
import useLogPageView from 'components/layout/use-log-page-view';
import { TopServiceModeNotification } from 'components/top-service-mode-notification';
import { useAppStateChange } from 'hooks/app-state-change/use-app-state-change';
import { useResetStoreResetCartResetServiceModeTimeout } from 'hooks/reset-store-timeout';
import { useForter } from 'hooks/use-forter';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

/**
 for miscellaneous generic components/hooks ONLY - if platform specific put in ./platform-specific-miscellaneous(.web.)tsx
 */
export const GenericMiscellaneous = () => {
  const enableTopOrderStatusBar = useFlag(LaunchDarklyFlag.ENABLE_TOP_ORDER_STATUS_BAR);

  const [showLanguageSelectorModal, setShowLanguageSelectorModal] = useState(false);

  const handleModalDismiss = useCallback(() => {
    setShowLanguageSelectorModal(false);
  }, []);

  useResetStoreResetCartResetServiceModeTimeout();
  useForter();
  useAppStateChange();
  useLogPageView(); // leave here to avoid higher level re-renders on page change

  return (
    <>
      {!enableTopOrderStatusBar && (
        <View>
          <TopServiceModeNotification />
        </View>
      )}
      <ErrorNetwork />
      {showLanguageSelectorModal && <LanguageSelectorModal onModalDismiss={handleModalDismiss} />}
      <StoreTimer />
      <AutoSelectClosestStorePromptWrapper />
    </>
  );
};
